import React from "react";
import ThurentEventForm from "./ThurentEventForm";

function Hero() {
  return (
    <div className="th-hero">
      <div className="th-hero__container">
        <div className="th-hero__cake">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="66"
            height="66"
            viewBox="0 0 66 66"
            fill="none"
          >
            <g clip-path="url(#clip0_1_1284)">
              <path
                d="M38.7808 49.9117L27.7363 36.3951"
                stroke="#E4E4E4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M38.8505 31.1925L44.3435 46.7798"
                stroke="#E4E4E4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M46.3427 26.9756L49.8713 38.8586C50.5874 41.2693 49.5397 43.8552 47.3469 45.0894L35.6818 51.6552C33.4891 52.8893 30.7349 52.4433 29.0455 50.5805L20.7178 41.3986"
                stroke="#E4E4E4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M37.552 19.0843C37.4943 19.1168 37.4504 19.1616 37.3937 19.1958C34.1967 15.4082 28.6661 14.2941 24.1874 16.8149C19.6852 19.349 17.7753 24.6957 19.398 29.4117C19.1055 29.5228 18.812 29.6322 18.5322 29.7897C15.5154 31.4877 14.4465 35.3093 16.1435 38.3244C17.8425 41.3429 21.6632 42.4102 24.68 40.7122C26.3605 39.7663 27.4088 38.1534 27.7391 36.3956C29.9938 36.7476 32.3771 36.3799 34.5205 35.1735C36.4809 34.0701 37.9435 32.4316 38.8469 30.5455C40.4155 31.0114 42.1617 30.8726 43.6998 30.0069C46.7166 28.3089 47.7866 24.4888 46.0876 21.4703C44.3906 18.4552 40.5688 17.3863 37.552 19.0843Z"
                stroke="#E4E4E4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M30.3995 20.6435L30.6509 23.8113"
                stroke="#E4E4E4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M30.8972 29.9569L30.7862 30.1086"
                stroke="#E4E4E4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M24.5691 25.3567L24.3789 25.2092"
                stroke="#E4E4E4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M22.2117 34.9332L23.3851 31.9794"
                stroke="#E4E4E4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M39.3817 24.8409L36.2227 25.1831"
                stroke="#E4E4E4"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1_1284">
                <rect
                  width="48"
                  height="48"
                  fill="white"
                  transform="translate(0 23.5437) rotate(-29.3731)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className="th-hero__party">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="53"
            height="53"
            viewBox="0 0 53 53"
            fill="none"
          >
            <path
              d="M22.6575 21.7642C18.9045 19.7516 15.6822 19.1718 14.605 20.5595C13.1078 22.4857 16.3141 27.4792 21.7643 31.7111C27.2146 35.9433 32.8459 37.8101 34.3428 35.8819C35.5409 34.3407 33.7265 30.8324 30.1593 27.3238"
              stroke="#E9E9E9"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M33.9765 36.2265L12.3882 45.3311C11.3777 45.7574 10.2953 44.9004 10.4763 43.821L14.2671 21.2591"
              stroke="#E9E9E9"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M34.7773 7.21146L34.7816 7.25796M14.6182 14.7172L14.6224 14.7637"
              stroke="#E9E9E9"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M37.8135 20.3983C36.4938 20.5186 35.3267 19.5463 35.2065 18.2266C35.0862 16.9069 36.0585 15.7397 37.3782 15.6195C38.6979 15.4993 39.865 16.4715 39.9853 17.7912C40.1055 19.1109 39.1332 20.2781 37.8135 20.3983Z"
              stroke="#E9E9E9"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21.3157 15.3892C21.3157 15.3892 20.9011 11.6539 16.873 9.1329"
              stroke="#E9E9E9"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24.806 27.2916C24.806 27.2916 30.9598 20.1363 27.1944 10.3774"
              stroke="#E9E9E9"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M43.5238 28.0398C43.5238 28.0398 37.993 24.7256 32.1409 29.4872"
              stroke="#E9E9E9"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div className="th-hero__text">
          <span className="th-hero__text__title">Plan. Invite. Involve.</span>
          <br />
          <span className="th-hero__text__subtitle">We Handle the Rest.</span>
        </div>
        <div className="th-hero__subtext">
          <span className="th-hero__subtext__title">
            Effortless event planning, all in one place. Easily manage event
            details,
          </span>
          <br />
          <span className="th-hero__subtext__subtitle">
            send invitations, book a priest, rent tents, and order catering—
            <br />
            stress-free!
          </span>
        </div>
      </div>
      <div className="th-plan">
        <ThurentEventForm />
      </div>
    </div>
  );
}

export default Hero;
